import ShopifyProduct from "~/types/shopify/ShopifyProduct";
import { BOUQUET, BUNDLE, SUBSCRIPTION,FilterBouquetsLandingProducts,FilterBundleLandingProducts,invokeShopifyQuery, testSubsQuery, FilterProductByCategory, FilterLandingProducts, FilterProductBySpecificTags } from "~/utils/shopify";
import ProcessLineItemsMixin from "~/mixin/process-lineitems-mixin";

const url = "/products/query";
const datadogErrorUrl = "datadog/events/error";

export default {
    data() {
      return {
        bouquetResponse: [],
        bouquetError: null,
        bouquetLoading: false,
        giftsetResponse: [],
        giftsetError: null,
        giftsetLoading: false,
        subscriptionResponse: [],
        subscriptionError: null,
        subscriptionLoading: false,
        nextAvailableBouquetResponse: [],
        nextAvailableProductsResponse: [],
      };
    },
    mixins: [ProcessLineItemsMixin],
    methods: {
        async getBouquets(options = {}, headers = {}) {
            this.bouquetLoading = true;
            try {
              const response = await this.$axios.$post(url, {productType: BOUQUET, ...options}, headers);
              this.bouquetResponse = this.mapProducts(response);
            } catch (error) {
                this.bouquetError = error;
                await this.$axios.$post(datadogErrorUrl, {error: {"name": "FLOWERS-NOT-FOUND", "ddSessionId": this.getatadogSessionID()}}, headers);
            } finally {
                this.bouquetLoading = false;
            }
        },
        async getLandingBouquets(dateCode) {
            this.bouquetLoading = true;
            try {
              const response = await invokeShopifyQuery(FilterBouquetsLandingProducts(dateCode, BOUQUET));
              this.bouquetResponse = this.mapProducts(response);
            } catch (error) {
              this.bouquetError = error;
            } finally {
              this.bouquetLoading = false;
            }
          },

        async getGiftsets(options = {}, headers = {}) {
            this.giftsetLoading = true;
            try {
              const response = await this.$axios.$post(url, {productType: BUNDLE, ...options}, headers);
              this.giftsetResponse = this.mapProducts(response);
            } catch (error) {
                this.giftsetError = error;
                await this.$axios.$post(datadogErrorUrl, {error: {"name": "GIFTSETS-NOT-FOUND", "ddSessionId": this.getatadogSessionID()}}, headers);
            } finally {
                this.giftsetLoading = false;
            }
        },
        async getLandingGiftsets(dateCode) {
            this.giftsetLoading = true;
            try {
              const response = await invokeShopifyQuery(FilterBundleLandingProducts(dateCode, BUNDLE));
              this.giftsetResponse = this.mapProducts(response);
            } catch (error) {
              this.giftsetError = error;
            } finally {
              this.giftsetLoading = false;
            }
          },

        async getSubscriptions(options = {}, headers = {}) {
            this.subscriptionLoading = true;
            try {
              // const response = await this.$axios.$post(url, {productType: SUBSCRIPTION, ...options}, headers);
              const response = await invokeShopifyQuery(testSubsQuery("TestSubs", "TestSubs")); //TODO: undo
              const responseSubs6 = await invokeShopifyQuery(testSubsQuery("sub6", "sub6")); //TODO: undo
              const responseSubs3 = await invokeShopifyQuery(testSubsQuery("sub3", "sub3")); //TODO: undo
              const responseSubsBday = await invokeShopifyQuery(testSubsQuery("bDaySub", "bDaySub"));
              const responseWinterSubs = await invokeShopifyQuery(testSubsQuery("wSub", "wSub"));
              const responseSubsMday = await invokeShopifyQuery(testSubsQuery("mDaySub", "mDaySub"));
              const responseSubsVday = await invokeShopifyQuery(testSubsQuery("vDaySub", "vDaySub"));
              const finalResponse = [...this.mapProducts(responseSubsVday), ...this.mapProducts(responseSubsBday),...this.mapProducts(responseWinterSubs), ...this.mapProducts(responseSubsMday), ...this.mapProducts(responseSubs6),...this.mapProducts(responseSubs3) , ...this.mapProducts(response)];
              this.subscriptionResponse = finalResponse;
            } catch (error) {
                this.subscriptionError = error;
                await this.$axios.$post(datadogErrorUrl, {error: {"name": "SUBSCRIPTIONS-NOT-FOUND", "ddSessionId": this.getatadogSessionID()}}, headers);
            } finally {
                this.subscriptionLoading = false;
            }
      },

      async getNextAvailableBouquets(dateCode) {
        try {
          const response = await invokeShopifyQuery(FilterBouquetsLandingProducts(dateCode, BOUQUET));
          this.nextAvailableBouquetResponse = this.mapProducts(response);
        } catch (error) {
        }
      },
      async getProductsByCategory(dateCode, tag, region, isLandingProduct, regionWiseQuery = false) {
        try {
          let response = "";
          if (regionWiseQuery) {
            response = await invokeShopifyQuery(FilterProductBySpecificTags(tag, isLandingProduct));
          } else {
            response = await invokeShopifyQuery(FilterProductByCategory(dateCode, tag, region, isLandingProduct));
          }
          return  this.mapProducts(response);
        } catch (error) {
          return null;
        }
      },
      async getNextAvailableLandingProducts(dateCode, query) {
        try {
          const response = await invokeShopifyQuery(FilterLandingProducts(dateCode, query));
          this.nextAvailableProductsResponse = this.mapProducts(response);
        } catch (error) {
          console.log(error);
        }
      },
        mapProducts(response) {
            if (!response?.data?.products?.edges) return [];
            const products = response.data.products.edges.map((edge) => new ShopifyProduct(edge.node));
            return products;
        },
    }
}
